<template>
  <div>
    <router-view />
    <Bottom></Bottom>

  </div>
</template>
<script>
import Bottom from '@/components/Layout/Bottom.vue'
export default {
  components: { Bottom },
  data () {
    return {
      indexKey: '1',
      collapsed: false

    }
  },
  async created () {

  },
  methods: {
    handleClick ({ key }) {
      switch (key) {
        case '1':
          this.$router.replace('/user/chartlet')
          break
        case '2':
          this.$router.replace('/user/person')
          break
      }
    }

  }
}
</script>
<style lang="less" scoped>
.ant-layout.ant-layout-has-sider {
  flex-direction: row;
  min-height: 100vh;
}
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 32px;

  margin: 16px;
  h1 {
    color: #fff;
    font-size: 20px;
    margin: 0 0 0 12px;
    font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
    font-weight: 600;
    vertical-align: middle;
  }
}
</style>
